import { render, staticRenderFns } from "./RemoveParticipantModal.vue?vue&type=template&id=60a05167&scoped=true&"
import script from "./RemoveParticipantModal.vue?vue&type=script&lang=js&"
export * from "./RemoveParticipantModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveParticipantModal.vue?vue&type=style&index=0&id=60a05167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a05167",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a05167')) {
      api.createRecord('60a05167', component.options)
    } else {
      api.reload('60a05167', component.options)
    }
    module.hot.accept("./RemoveParticipantModal.vue?vue&type=template&id=60a05167&scoped=true&", function () {
      api.rerender('60a05167', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/RemoveParticipantModal.vue"
export default component.exports